import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LogoutStateHandlerService {
  loginStateUrl: string | undefined | null;
  params: any = {};
  queryParams: any = {}
  constructor() { }
}
